// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/touchpoint_proposals.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
import { TouchpointProposal } from "../../datagateway/v1/touchpoint_proposals_pb";
/**
 * @generated from message mono.projectdata.v1.DraftTouchpointProposalsRequest
 */ export class DraftTouchpointProposalsRequest extends Message {
    static fromBinary(bytes, options) {
        return new DraftTouchpointProposalsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DraftTouchpointProposalsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DraftTouchpointProposalsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DraftTouchpointProposalsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string interaction_id = 2;
   */ _define_property(this, "interactionId", ""), /**
   * only existing files in this Pursuit
   *
   * @generated from field: repeated string attachment_ids = 3;
   */ _define_property(this, "attachmentIds", []), /**
   * @generated from field: string user_id = 4;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DraftTouchpointProposalsRequest, "runtime", proto3);
_define_property(DraftTouchpointProposalsRequest, "typeName", "mono.projectdata.v1.DraftTouchpointProposalsRequest");
_define_property(DraftTouchpointProposalsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "interaction_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "attachment_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListTouchpointProposalsRequest
 */ export class ListTouchpointProposalsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListTouchpointProposalsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListTouchpointProposalsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListTouchpointProposalsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListTouchpointProposalsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string interaction_id = 2;
   */ _define_property(this, "interactionId", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListTouchpointProposalsRequest, "runtime", proto3);
_define_property(ListTouchpointProposalsRequest, "typeName", "mono.projectdata.v1.ListTouchpointProposalsRequest");
_define_property(ListTouchpointProposalsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "interaction_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReviewTouchpointProposalRequest
 */ export class ReviewTouchpointProposalRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviewTouchpointProposalRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewTouchpointProposalRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewTouchpointProposalRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewTouchpointProposalRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string interaction_id = 2;
   */ _define_property(this, "interactionId", ""), /**
   * @generated from field: string proposal_id = 3;
   */ _define_property(this, "proposalId", ""), /**
   * accepted or rejected
   *
   * @generated from field: string decision = 4;
   */ _define_property(this, "decision", ""), /**
   * @generated from field: optional string edited_value = 5;
   */ _define_property(this, "editedValue", void 0), /**
   * @generated from field: string user_id = 6;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 7;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewTouchpointProposalRequest, "runtime", proto3);
_define_property(ReviewTouchpointProposalRequest, "typeName", "mono.projectdata.v1.ReviewTouchpointProposalRequest");
_define_property(ReviewTouchpointProposalRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "interaction_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposal_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "edited_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 6,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DraftTouchpointProposalsResponse
 */ export class DraftTouchpointProposalsResponse extends Message {
    static fromBinary(bytes, options) {
        return new DraftTouchpointProposalsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DraftTouchpointProposalsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DraftTouchpointProposalsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DraftTouchpointProposalsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.TouchpointProposal proposals = 1;
   */ _define_property(this, "proposals", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DraftTouchpointProposalsResponse, "runtime", proto3);
_define_property(DraftTouchpointProposalsResponse, "typeName", "mono.projectdata.v1.DraftTouchpointProposalsResponse");
_define_property(DraftTouchpointProposalsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposals",
            kind: "message",
            T: TouchpointProposal,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListTouchpointProposalsResponse
 */ export class ListTouchpointProposalsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListTouchpointProposalsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListTouchpointProposalsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListTouchpointProposalsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListTouchpointProposalsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.TouchpointProposal proposals = 1;
   */ _define_property(this, "proposals", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListTouchpointProposalsResponse, "runtime", proto3);
_define_property(ListTouchpointProposalsResponse, "typeName", "mono.projectdata.v1.ListTouchpointProposalsResponse");
_define_property(ListTouchpointProposalsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposals",
            kind: "message",
            T: TouchpointProposal,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReviewTouchpointProposalResponse
 */ export class ReviewTouchpointProposalResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviewTouchpointProposalResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewTouchpointProposalResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewTouchpointProposalResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewTouchpointProposalResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.TouchpointProposal proposal = 1;
   */ _define_property(this, "proposal", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewTouchpointProposalResponse, "runtime", proto3);
_define_property(ReviewTouchpointProposalResponse, "typeName", "mono.projectdata.v1.ReviewTouchpointProposalResponse");
_define_property(ReviewTouchpointProposalResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal",
            kind: "message",
            T: TouchpointProposal
        }
    ]));
